/* src/app/system-utils/suspended-menu/suspended-menu.component.scss */
.suspended-menu-actions {
  width: 100%;
  background-color: darkblue;
  align-items: center;
  color: white;
  height: 30px;
  justify-items: center;
  cursor: move;
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-width: 200px;
  font-size: 10px;
  padding: 10px;
}
.suspended-menu-list {
  min-height: 60px;
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 4px;
}
.suspended-menu-actions-in {
  cursor: pointer;
  z-index: 100;
  line-height: 10px;
}
.suspended-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1215686275);
  overflow: auto;
  border-radius: 4px;
  right: 0;
  top: 50px;
  z-index: 100;
}
.suspended-menu-box {
  padding: 5px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 10px;
}
/*# sourceMappingURL=suspended-menu.component.css.map */
